import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Card, Heading } from "@icg360/design-system";

import { trackEvent, useFlags } from "utils";

import styles from "./featured-offers-shingle-reseal.module.scss";

// A/B test: Gutter cleaning / roof check-up copy only for Variation_A
const SUBHEADING_VARIATION_A =
  "Get a free gutter cleaning and roof check-up with Wind Defense";

export const FeaturedOfferShingleReseal = () => {
  const navigate = useNavigate();
  const { abTestWindDefenseFeaturedCopy } = useFlags();
  const featuredCopyVariation =
    abTestWindDefenseFeaturedCopy ?? "Control";
  const showGutterCleaningSubheading = featuredCopyVariation === "Variation_A";

  useEffect(() => {
    trackEvent("Featured Offer Shown", {
      offerInternalName: "wind-defense",
      featuredCopyVariation,
    });
  }, [featuredCopyVariation]);

  return (
    <Card className={styles.cardDS}>
      <div className={styles.title}>
        <Heading size="md">Property services</Heading>
      </div>
      <div className={styles.content}>
        <Heading size="lg" className={styles.heroTextDS}>
          {showGutterCleaningSubheading ? (
            SUBHEADING_VARIATION_A
          ) : (
            <>
              Sign up for a chance to{" "}
              <span className={styles.highlightText}>strengthen your roof</span>{" "}
              ahead of the next hurricane
            </>
          )}
        </Heading>
        <Button
          onPress={() => {
            trackEvent("Featured Offer Clicked", {
              offerInternalName: "wind-defense",
              featuredCopyVariation,
            });
            navigate(`/my/property-services/wind-defense`, {
              state: { from: "/my/overview" },
            });
          }}
          data-testid="get-started-btn"
          className={styles.getStartedButtonDS}
        >
          Get started
        </Button>
      </div>
    </Card>
  );
};
